import { HttpClient } from '@angular/common/http';
import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { take } from 'rxjs';
import { LegalInformationRule } from '../../models/legalInformationRule';
import { GeneralDataService } from '../../services/GeneralDataService';
import { InformationDialogComponent } from './information-dialog.component';

@Component({ standalone: false,
  selector: 'confirm-registration-dialog',
  templateUrl: 'confirm-registration-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['confirm-registration-dialog.component.scss']
})
export class ConfirmRegistrationDialogComponent {
  title: string= "Confirm your Registration";
  confirmButtonText = "Confirm";
  cancelButtonText = "Cancel";
  agreeChecked:boolean = false;
  emphasizeUserAction:boolean=false;
  termsOfUse:any;
  privacyPolicy:any;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<ConfirmRegistrationDialogComponent>, private httpClient: HttpClient, private sanitizer:DomSanitizer, private gdService:GeneralDataService, private dialog: MatDialog ) {
    this.getFileContent()
  }

  getFileContent(){
    let path1 = 'assets/text/terms_of_use.html';
    this.httpClient.get(path1, {responseType: "text"}).pipe(take(1)).subscribe(
      data => {
        this.termsOfUse = this.sanitizer.bypassSecurityTrustHtml(data);
    });
    let path2 = 'assets/text/privacy_policy.html';
    this.httpClient.get(path2, {responseType: "text"}).pipe(take(1)).subscribe(
      data => {
        this.privacyPolicy = this.sanitizer.bypassSecurityTrustHtml(data);
    });
  }

  get canConfirm(){
    return this.agreeChecked;
  }

  onConfirmClick() {
    this.dialogRef.close(this.agreeChecked);
  }

  onCancelClick() {
    this.dialogRef.close(false);
  }

  onScrollClick(){
    this.emphasizeUserAction=true;
  }

  public onConsumerDisclosureClick(){
    let lir=new LegalInformationRule();
    lir.typeId=4;
    this.gdService.getLegalInformation(lir).pipe(take(1)).subscribe(result=>{
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = true;
      dialogConfig.data={message: result.message};
      dialogConfig.minHeight=600;
      dialogConfig.minWidth=800;

      this.dialog.open(InformationDialogComponent,  dialogConfig).afterClosed().pipe(take(1)).subscribe(value=>{
        if(value){
          //nothing to do
        }
      });
    });
  }

}